import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { TalentProfile } from "../types";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_TALENT_PROFILE = "talentProfile";

const getData = async (props: { token: string }): Promise<TalentProfile> => {
  const url = `${END_POINT.BASE_URL}/v1/talent-profile`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
  const item: TalentProfile = res.data;
  const data: TalentProfile = {
    ...item,
  };

  return data;
};
export const useGetTalentProfile = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_TALENT_PROFILE],
    () => getData({ token }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );

  return queryData;
};
